import React from 'react';
import { Button, useTheme, useMediaQuery } from '@mui/material';
import { tokens } from '../../../theme';

const PrimaryButton = ({
  type = 'button',
  onClick = () => {},
  label = '',
  sx = {},
  disabled = false,
  variant = 'contained',
  color = 'primary',
  size = 'large',
  orgFace = false,
  fullWidthOnMobile = false,
  ...rest
}) => {
  const theme = useTheme();
  const theme2 = theme.palette.mode;
  const colors2 = tokens(theme2);
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  let customizedFace = !orgFace ? { backgroundColor: colors2.primary[600], color: 'white' } : {};

  return (
    <Button
      {...rest}
      size={isMobile ? 'medium' : size}
      type={type}
      onClick={onClick}
      variant={variant}
      disabled={disabled}
      color={color}
      fullWidth={fullWidthOnMobile && isMobile}
      sx={{
        ...customizedFace,
        borderRadius: 3,
        fontSize: { xs: '0.8rem', sm: '0.9rem' },
        px: { xs: 1.5, sm: 2.5 },
        py: { xs: 0.75, sm: 1 },
        minWidth: { xs: 'auto', sm: 64 },
        whiteSpace: 'nowrap',
        ...sx,
      }}
    >
      {label}
    </Button>
  );
};

export default PrimaryButton;